module.exports = __webpack_public_path__ + "static/media/supported-by.74c38c65.png";